import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';

import { environment } from '../../../environments/environment';
import { AuthService } from './auth.service';
import { ToastrMessageType } from '../enums/toastr-message-type.enum';
// import { ClassificationCategoriesRoutingModule } from '../../classification-categories/classification-categories-routing.mod

@Injectable()
export class GlobalService {

  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private toastr: ToastrService) { }

  httpGet(endpoint: string, requestBody?: any): Observable<any> {
    return this.http.get(`${environment.apiUrl}${endpoint}`, {
      headers: this.httpHeaders
    })
      .map(response => response);
  }

  httpPost(endpoint: string, requestBody?: any): Observable<any> {
    return this.http.post(`${environment.apiUrl}${endpoint}`, requestBody, {
      headers: this.httpHeaders
    })
      .map(response => response);
  }

  httpDelete(endpoint: string): Observable<any> {
    return this.http.delete(`${environment.apiUrl}${endpoint}`, {
      headers: this.httpHeaders
    })
      .map(response => response);
  }

  httpFile(endpoint: string, requestBody?: any): Observable<any> {
    const token = this.authService.getToken();
    const headers = new HttpHeaders()
      .set('Authorization', `Bearer ${token}`);
    return this.http.post(`${environment.apiUrl}${endpoint}`, requestBody, {
      headers: headers,
      responseType: 'blob'
    }).map((res) => {
        return new Blob([res], { type: 'application/octet-stream' });
      });
  }

  showMessage(message: string, type?: ToastrMessageType) {
    switch (type) {
      case ToastrMessageType.Error: this.toastr.error(message); break;
      case ToastrMessageType.Success: this.toastr.success(message); break;
      case ToastrMessageType.Warning: this.toastr.warning(message); break;
      default: this.toastr.info(message); break;
    }
  }

  get httpHeaders(): HttpHeaders {
    const token = this.authService.getToken();
    if (token) {
      const headers = new HttpHeaders()
        .set('Content-Type', 'application/json')
        .set('Cache-Control', 'no-cache')
        .set('Authorization', `Bearer ${token}`);

      return headers;
    }
  }

  handleErrorObservable(error: Response | any, message?: string) {
    console.error(error);

    if (!message)
      message = 'Something went wrong';

    message += ': ' + error.message;

    this.toastr.error(message, 'Error');
    return Observable.throw(error.message || error);
  }

  generateUUID() {
    let d = new Date().getTime();
    const uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
      const r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
    });
    return uuid;
  }

}
